module.exports = __webpack_public_path__ + "static/media/show_1.956b8efd.png";